// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/storage/v1/registered_model_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchDeleteRegisteredModelRequest, BatchDeleteRegisteredModelResponse, CountRegisteredModelRequest, CountRegisteredModelResponse, CreateRegisteredModelRequest, CreateRegisteredModelResponse, DeleteRegisteredModelRequest, DeleteRegisteredModelResponse, GetRegisteredModelByNameRequest, GetRegisteredModelByNameResponse, GetRegisteredModelRequest, GetRegisteredModelResponse, ListRegisteredModelsRequest, ListRegisteredModelsResponse, UpdateRegisteredModelRequest, UpdateRegisteredModelResponse } from "@buf/h2oai_mlops-storage.bufbuild_es/ai/h2o/mlops/storage/v1/registered_model_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.storage.RegisteredModelService
 */
export const RegisteredModelService = {
  typeName: "ai.h2o.storage.RegisteredModelService",
  methods: {
    /**
     * Registers a given experiment as registered model
     * This could be a 2 step process. Rather ModelVersionService.registerModelVersion can
     * be used directly.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.CreateRegisteredModel
     */
    createRegisteredModel: {
      name: "CreateRegisteredModel",
      I: CreateRegisteredModelRequest,
      O: CreateRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Searches the registered models based on the given find criteria.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.ListRegisteredModels
     */
    listRegisteredModels: {
      name: "ListRegisteredModels",
      I: ListRegisteredModelsRequest,
      O: ListRegisteredModelsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the registered model for the given model id.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.GetRegisteredModel
     */
    getRegisteredModel: {
      name: "GetRegisteredModel",
      I: GetRegisteredModelRequest,
      O: GetRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the registered model.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.UpdateRegisteredModel
     */
    updateRegisteredModel: {
      name: "UpdateRegisteredModel",
      I: UpdateRegisteredModelRequest,
      O: UpdateRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes the registered model.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.DeleteRegisteredModel
     */
    deleteRegisteredModel: {
      name: "DeleteRegisteredModel",
      I: DeleteRegisteredModelRequest,
      O: DeleteRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete more than one registered model.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.BatchDeleteRegisteredModel
     */
    batchDeleteRegisteredModel: {
      name: "BatchDeleteRegisteredModel",
      I: BatchDeleteRegisteredModelRequest,
      O: BatchDeleteRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Count the number of registered models.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelService.CountRegisteredModels
     */
    countRegisteredModels: {
      name: "CountRegisteredModels",
      I: CountRegisteredModelRequest,
      O: CountRegisteredModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.RegisteredModelService.GetRegisteredModelByName
     */
    getRegisteredModelByName: {
      name: "GetRegisteredModelByName",
      I: GetRegisteredModelByNameRequest,
      O: GetRegisteredModelByNameResponse,
      kind: MethodKind.Unary,
    },
  }
};

